import React, { useContext } from 'react';
import { shape, func, bool } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  formatDistance,
  getSellableQuantityNearbyStore,
  getNearbyStoreInStock,
  productShape
} from '../../helpers/pod-fulfillment-utils';
import { CheckNearByStore } from './CheckNearbyStore';
import { InStockIcon } from '../../helpers/icon-utils';
import { isFunction, isMobile } from '../../../components/helper/utils';
import { PICKUP_TEMPLATES } from '../../templates/templatesConstant';

export const InStockNearby = ({
  product,
  onCheckNearbyStoresClick,
  customRender

}) => {
  const { channel } = useContext(ExperienceContext);
  const nearbyStore = getNearbyStoreInStock(product);

  const emptyComponent = () => {
    if (isFunction(customRender)) {
      return customRender({ pickUpTemplate: PICKUP_TEMPLATES.EMPTY_STORE_MESSAGE,
        isEmptyComponent: true,
        icon: null,
        value: {} });
    }
    return (<div className="store__message" />);
  };

  if (!(product && nearbyStore)) {
    return emptyComponent();
  }

  const { storeName, distance } = nearbyStore;

  if (!(distance && storeName)) {
    return emptyComponent();
  }

  const sellableQuantity = getSellableQuantityNearbyStore(product);
  if (!sellableQuantity) {
    return emptyComponent();
  }

  const formattedQty = sellableQuantity > 999 ? '999+' : sellableQuantity;

  const storeNameLink = isMobile(channel)
    ? <span className="store__primary store__store-name store__text-adjustment">{storeName}</span>
    : (
      <CheckNearByStore
        product={product}
        onCheckNearbyStoresClick={onCheckNearbyStoresClick}
        nearbyStoreName={storeName}
      />
    );

  if (isFunction(customRender)) {
    return customRender(
      { pickUpTemplate: PICKUP_TEMPLATES.IN_STOCK_NEARBY,
        icon: InStockIcon,
        values:
        { formattedQty, storeName, storeNameLink, distance: formatDistance(distance) } });
  }

  return (
    <div className="store__message">
      <div className="store__icon">{InStockIcon}</div>
      <div className="store__text-box">
        <div className="store__dark">Pickup</div>
        <div id="check-nearby-store" className="store__second-line">
          <span className="store__success">{`${formattedQty} nearby`}</span>
          <span className="store__primary">{' at '}</span>
          {storeNameLink}
          <span className="store__primary">{` | ${formatDistance(distance)} mi away`}</span>
        </div>
      </div>
    </div>
  );
};

InStockNearby.propTypes = {
  product: shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: func,
  customRender: func
};

InStockNearby.defaultProps = {
  onCheckNearbyStoresClick: () => {},
  customRender: null
};
